/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioVolumeSMinusIcon24Solid = forwardRef('MediaAudioVolumeSMinusIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M10.512 3.677 5.572 8H3a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h2.571l4.941 4.323c.97.849 2.488.16 2.488-1.129V4.806c0-1.29-1.518-1.978-2.488-1.13Z" }),
        React.createElement("path", { d: "M15.5 11a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2h-7Z" })));
});
